export default __webpack_public_path__ + "static/30-c580111468374335321e1144fa990213.png";